<mat-dialog-content style="text-align: center">
  <p style="margin: 5px;">{{'batches.confirm-delete.question' | translate}}</p>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-raised-button (click)="closeDialog()">{{'batches.confirm-delete.option-no' | translate}}</button>
  <button mat-raised-button [mat-dialog-close]="true" color="primary">{{'batches.confirm-delete.option-yes' | translate}}</button>
</mat-dialog-actions>

